import LocationAddress from './LocationAddress';

export default LocationAddress;
